<template>
  <v-card class="acessos-por-pagina-card card-title pa-3">
    <v-container class="pa-0 card-header">
      <v-card-title class="table-card-title">Acessos por página</v-card-title>
      <v-card-subtitle class="pa-3 pb-1 subtitle">Quantidade de acessos que as telas do aplicativo tiveram.</v-card-subtitle>
      <v-container v-if="series.length > 0" class="d-flex flex-row justify-space-between pb-0 pt-0">
        <p>Página:</p>
        <p>Qtd. acessos</p>
      </v-container>
    </v-container>
    <mf-loading loader="loader" loader-type="table">
      <div>
        <v-divider v-if="series.length > 0"></v-divider>
        <v-data-table v-if="series.length > 0" :items="series" hide-default-footer disable-pagination hide-default-headers class="table-container">
          <template v-slot:item="{ item }">
            <tr>
              <td class="table-text">{{ item.screen }}</td>
              <td class="table-text text-right">
                <span class="table-count">{{ item.access_count.toLocaleString() }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <empty-chart v-else-if="series.length === 0" />
      </div>
      <v-container v-if="series.length > 0" fluid class="pa-0 navigator-container">
        <chart-navigator
          v-if="series.length > 0 || series.length > 0"
          :selectedPeriod="chartPeriod"
          :chart-index="chartIndex"
          :metrics-length="metricsLength"
          :metrics-period="metricsPeriod"
          @navigateTo="navigateTo"
        />
      </v-container>
    </mf-loading>
  </v-card>
</template>

<script>
import EmptyChart from '@/modules/mobile/desempenho/views/components/EmptyChart'
import { QUERY_GET_APP_ACCESSES_PER_SCREEN } from '../../graphql'
import ChartNavigator from '@/components/ChartNavigator'
import getAppMetricsNavigatorPeriod from '@/services/getAppMetricsNavigatorPeriod'

export default {
  components: {
    ChartNavigator,
    EmptyChart,
  },
  props: {
    metricsPeriod: String,
  },
  data: () => ({
    chartIndex: 0,
    apolloResponse: null,
  }),
  computed: {
    series() {
      if (!this.appAccessesPerScreen) return []
      const accessCountByScreen = {}

      this.appAccessesPerScreen[this.chartIndex].metrics.forEach((metric) => {
        const screenName = this.parseScreenNames(metric.screen)
        if (!accessCountByScreen[screenName]) {
          accessCountByScreen[screenName] = {
            screen: screenName,
            access_count: 0,
          }
        }
        accessCountByScreen[screenName].access_count += metric.access_count
      })

      return Object.values(accessCountByScreen).filter((item) => item.screen !== null)
    },
    metricsLength() {
      if (!this.appAccessesPerScreen) return 0
      return this.appAccessesPerScreen.length - 1
    },
    chartPeriod() {
      const currentPeriod =
        this.metricsPeriod === 'MONTHLY' ? this.appAccessesPerScreen[this.chartIndex].month : this.appAccessesPerScreen[this.chartIndex].year
      const { navigatorPeriod } = getAppMetricsNavigatorPeriod(this.metricsPeriod, currentPeriod)
      return navigatorPeriod
    },
  },
  apollo: {
    appAccessesPerScreen: {
      query: QUERY_GET_APP_ACCESSES_PER_SCREEN,
      variables() {
        return { metricsPeriod: this.metricsPeriod }
      },
    },
  },
  watch: {
    metricsPeriod() {
      this.chartIndex = 0
    },
  },
  methods: {
    navigateTo(newIndex) {
      this.chartIndex = newIndex
    },
    parseScreenNames(screenName) {
      switch (screenName) {
        case 'Sales':
        case 'club_offers':
        case 'SalesActivated':
          return 'Ofertas'

        case 'Home':
        case 'tab_club_home':
        case 'TabClubHome':
          return 'Home do Clube'

        case 'FlyersScreen':
        case 'FlyerScreen':
        case 'tab_flyer_screen':
        case 'flyer_screen':
          return 'Encartes'

        case 'Lists':
        case 'tab_shopping_lists':
          return 'Listas de Compras'

        case 'UnitSelect':
        case 'Units':
        case 'SelectNewStore':
        case 'select_store_new':
        case 'OnboardingSelectUnit':
        case 'onboarding_select_unit':
          return 'Selecionar Loja'

        case 'Notifications':
          return 'Notificações'

        case 'Login':
          return 'Login'

        case 'UserRegister':
          return 'Cadastro'

        case 'Economizer':
        case 'tab_economizer':
          return 'Economizômetro'

        case 'CreateList':
          return 'Criar Lista de Compras'

        case 'Config':
          return 'Configurações'

        case 'ExternalSite':
          return 'Link Externo'

        case 'Raffle':
        case 'RaffleDetail':
        case 'RaffleProductsScreen':
          return 'Sorteio'

        case 'RaffleRulesScreen':
        case 'RaffleCouponsScreen':
        case 'RaffleRulesWebViewScreen':
          return 'Regras do Sorteio'

        case 'StoreDetails':
        case 'store_details':
          return 'Detalhes da Loja'

        case 'Chatbot':
          return 'Assistente'

        case 'ConfigTutorial':
          return 'Tutorial'

        case 'LostPass':
          return 'Esqueci Minha Senha'

        case 'ConfigUserData':
          return 'Meus Dados'

        case 'ConfigClubTerms':
          return 'Termos do Clube'

        case 'ConfigTerms':
          return 'Regulamento'

        case 'Points':
          return 'Pontos'

        case 'Cashback':
        case 'tab_cashback':
          return 'Cashback'

        case 'CashbackTutorial':
          return 'Tutorial do Cashback'

        case 'CashbackVoucher':
          return 'Voucher do Cashback'

        case 'ExcludeSite':
          return 'Exclusão de Dados'

        case 'PointsTutorial':
          return 'Tutorial de Pontos'

        case 'PointsHistory':
          return 'Histórico de Pontos'

        case 'PointsVoucher':
          return 'Pontos do Voucher'

        case 'ConfigPassword':
          return 'Alterar Senha'

        case 'ConfigUserDataUpdate':
          return 'Edição de Dados'

        case 'SalesDetails':
        case 'offers_product_details':
          return 'Detalhes da Oferta'

        case 'FlyerDetails':
        case 'flyer_details':
          return 'Detalhes Encarte'

        case 'ClubShoppingListDetails':
        case 'club_shopping_list_details':
          return 'Detalhes da Lista de Compras'

        case 'EconomizerDetails':
        case 'economizer_details':
          return 'Detalhes Economizômetro'

        case 'MyAddresses':
        case 'my_addresses':
          return 'Meus Endereços'

        case 'ContactUs':
        case 'contact_us':
        case 'ConfigContactUs':
          return 'Fale Conosco'

        case 'WorkUs':
        case 'work_us':
          return 'Trabalhe Conosco'

        case 'AddressForm':
        case 'address_form':
          return 'Cadastrar Endereço'

        case 'Stores':
        case 'tab_stores':
        case 'stores':
          return 'Lojas'

        case 'tab_menu':
        case 'menu':
          return 'Menu'

        case 'coupons_wallet':
        case 'CouponsWallet':
          return 'Carteira de Cupons'

        case 'coupon_details':
        case 'CouponDetails':
          return 'Detalhes do Cupom'

        case 'coupons_register':
        case 'CouponsRegister':
          return 'Resgate de Cupom'

        case 'coupons_history':
        case 'CouponsHistory':
          return 'Histórico de Cupons'

        case 'LoyaltyCard':
        case 'loyalty_card':
          return 'Cartão de Fidelidade'

        case 'Favorites':
          return 'Favoritos'

        case 'OffersSchedule':
        case 'offers_schedule':
          return 'Agenda de Ofertas'

        case 'TabRaffle':
        case 'tab_raffle':
          return 'Aba Sorteio'

        default:
          return null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.acessos-por-pagina-card {
  height: 500px;
  position: relative;
}
.card-header {
  height: 120px;
}
p {
  color: $cinza-d10;
  font-size: 12px;
  margin: 0;
}
.table-title {
  position: absolute;
  top: 0;
  bottom: 0;
}
.table-container {
  overflow-y: scroll;
  height: 320px;
}
.table-text {
  color: $cinza-d10;
}
.table-count {
  width: 100%;
  text-align: right;
}
.navigator-container {
  position: absolute;
  bottom: 20px;
  right: 12px;
}
</style>
